
import React from "react";
import { Facebook, Instagram, Mail } from "lucide-react";
import { FooterSocialLink } from "./FooterSocialLink";

export const FooterSocialSection = () => {
  return (
    <div>
      <h4 className="font-playfair text-lg font-medium mb-4 text-yarn-slate">Connect With Us</h4>

      <div className="flex flex-wrap items-center gap-4 mb-4">
        <FooterSocialLink
          href="https://www.facebook.com/IntelliStitchApp"
          icon={Facebook}
          label="Facebook"
        />

        <FooterSocialLink
          href="https://www.instagram.com/intellistitch/"
          icon={Instagram}
          label="Instagram"
        />

        <FooterSocialLink
          href="mailto:info@intellistitch.ca"
          icon={Mail}
          label="Email Us"
        />
      </div>

      <a
        href="mailto:info@intellistitch.ca"
        className="text-yarn-slate hover:text-primary text-sm transition-colors inline-flex items-center gap-2 mt-1"
      >
        <span className="underline underline-offset-2">info@intellistitch.ca</span>
      </a>

      <div className="mt-4 text-sm text-yarn-slate/80">
        <p>Join our knitting community and stay updated with the latest patterns and features.</p>
      </div>
    </div>
  );
};
